import { render, staticRenderFns } from "./le-address-choose.vue?vue&type=template&id=19a28c68&"
import script from "./le-address-choose.vue?vue&type=script&lang=js&"
export * from "./le-address-choose.vue?vue&type=script&lang=js&"
import style0 from "./le-address-choose.vue?vue&type=style&index=0&id=19a28c68&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports